import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "background_image",
  "background_color",
  { type: 'separator' },
  "meta_description"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopPageDescriptor: _generatedShopPageDescriptor,
  shopPageBlocDefinition,
  shopPageDashboardLayout,
  shopPageConfig,
  shopPageResolveConfig,
  shopPageProperties,
} = doodBlockConfig(
  {
    name: "Shop page",
    internal_name: "Shop page",
    url: ":shopCity/:shopType/:shopSlug",
    defaultParent: [/^Main Layout$/i],
    componentType: 'ShopPageComponent',
    category: 'page',
    description: "Shop page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.shop-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'shop-header-block', type: 'HeaderBlockComponent' },
          { id: 'shop-page-hero-block', type: 'ShopHeroImageBlockComponent' },
          { id: 'shop-page-product-list-block', type: 'ShopProductListBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.shop-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.shop-page.background-image.label",
        help: "pages.blocks.shop-page.background-image.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.shop-page.background-color.label",
      }
    }),
    meta_description: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.shop-page.meta-description.label",
        help: "pages.blocks.shop-page.meta-description.help",
        rows: 3,
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shop-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shop-page.fieldset.appearance.label",
            fields: ["background_color", "background_image"],
          },
          {
            legend: "pages.blocks.shop-page.fieldset.seo.label",
            fields: ["meta_description"],
          },
          {
            legend: "pages.blocks.shop-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function shopPageDescriptor(): IBlockDescriptor;
export function shopPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopPageDescriptor, shopPageProperties, fieldOrder);
}

export {
  shopPageBlocDefinition,
  shopPageDashboardLayout,
  shopPageProperties,
  shopPageConfig,
  shopPageResolveConfig,
};

export type ShopPageConfig = typeof shopPageConfig;
